export const VOLUME_VIEW_OPTIONS = [
  { value: 'daily', label: 'По дням', title: 'Показать значения по дням' },
  {
    value: 'cumulative',
    label: 'Накопительно',
    title: 'Накопительный итог - помогает понять динамику выполнения плана'
  }
]

export const CONVERSION_WINDOW_OPTIONS = [
  {
    value: '1',
    label: '1д',
    title: 'Окно 1 день - конверсии рассчитываются отдельно по каждому дню'
  },
  {
    value: '3',
    label: '3д',
    title: 'Скользящее окно 3 дня - конверсии рассчитываются за последние 3 дня для сглаживания'
  },
  {
    value: '7',
    label: '7д',
    title: 'Скользящее окно 7 дней - конверсии рассчитываются за последние 7 дней для сглаживания'
  }
]

export const CHART_MODE_OPTIONS = [
  { value: 'volume', label: 'Объем' },
  { value: 'conversion', label: 'Конверсии' }
]

export const REVENUE_VIEW_OPTIONS = [
  { value: 'daily', label: 'По дням', title: 'Показать выручку по дням' },
  {
    value: 'cumulative',
    label: 'Накопительно',
    title: 'Накопительная выручка - помогает понять выполнение плана'
  }
]
